async function formImporter() {
	await import(/* webpackChunkName: "form" */ "./index");
}

export default formImporter;
